import { render } from "./Android.vue?vue&type=template&id=6523ff06&scoped=true"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import "./Android.vue?vue&type=style&index=0&id=6523ff06&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6523ff06"]])

export default __exports__